// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"08bdfeda","239":"821c7b1c","389":"872ca1aa","455":"0dba18ec","977":"2dd773fa"}[chunkId] + ".chunk.js";
};